// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import './BurgerIcon.scss';

@observer class BurgerIcon extends Component<any, any> {
	render() {
		return (
			<div className={this.props.nav ? "burger-icon cross" : "burger-icon"} onClick={this.props.handler}>
				<span className="bar-1 bar"></span>
				<span className="bar-2 bar"></span>
				<span className="bar-3 bar"></span>
			</div>
		)
	}
}

export default BurgerIcon;

